import CustomerProfileList from './CustomerProfileList'

export default CustomerProfileList
